<template>
    <div class="chart-container">
        <div class="c-row">
            <canvas ref="ecg1" :width="width" :height="height"></canvas>
        </div>
        <div class="c-row">
            <canvas ref="spo2" :width="width" :height="height"></canvas>
        </div>
        <div class="c-row">
            <canvas ref="resp" :width="width" :height="height"></canvas>
        </div>
    </div>
</template>

<script>
import * as smoothie from 'smoothie'
export default {
    props: {
        device: { type: Object, required: true }
    }, 
    methods: {
        addData (dat) {
            let t = Date.now()
            // ECG1, ECG2, RESP, TEMP, SPO2
            this.charts[0].l.append(t, parseInt(dat[0]))
            this.charts[1].l.append(t, parseInt(dat[1]))
            this.charts[2].l.append(t, parseInt(dat[4]))
        },
        append (dat) {
            if (!this.charts) return

            switch (dat.t) {
                case 'ecg_wave': {
                    this.charts[0].l.append(parseInt(dat._t, 10), parseInt(dat.d, 10))
                    break
                }
                case 'spo2_wave': {
                    this.charts[1].l.append(parseInt(dat._t, 10), parseInt(dat.d, 10))
                    break
                }
                case 'resp_wave': {
                    this.charts[2].l.append(parseInt(dat._t, 10), parseInt(dat.d, 10))
                    break
                }
                default: {
                    console.log(`Unknown key: ${dat.t}`)
                    console.log(dat)
                }
            }
        }
    },
    mounted () {
        this.charts = [
            {
                name: 'ecg1',
                l: new smoothie.TimeSeries(),
                s: {strokeStyle: this.device.ecg1_color},
                o: new smoothie.SmoothieChart({
                    millisPerPixel: this.device.ecg_wave_speed,
                    maxValue: this.device.ecg_graph_max, minValue: this.device.ecg_graph_min
                })
            },
            {
                name: 'spo2',
                l: new smoothie.TimeSeries(),
                s: {strokeStyle: this.device.spo2_color},
                o: new smoothie.SmoothieChart({
                    millisPerPixel: this.device.spo2_wave_speed,
                    maxValue: this.device.spo2_graph_max, minValue: this.device.spo2_graph_min
                })
            },
            {
                name: 'resp',
                l: new smoothie.TimeSeries(),
                s: {strokeStyle: this.device.resp_color},
                o: new smoothie.SmoothieChart({
                    millisPerPixel: this.device.resp_wave_speed,
                    maxValue: this.device.resp_graph_max, minValue: this.device.resp_graph_min
                })
            }
        ]

        for (let chart of this.charts) {
            chart.o.addTimeSeries(chart.l, chart.s)
            chart.o.streamTo(this.$refs[chart.name], this.delay);
        }
    },
    data () {
        return {
            charts: null,
            width: 775,
            height: 100,
            delay: 10,
            millisPerPixel: 25
        }
    }
}
</script>

<style lang="scss" scoped>
    .c-row {
		font-size: 0;
        margin-bottom: 5.5px;
	}
</style>